/**
 * Created by hj on 2017/8/16.
 */
import React from 'react';
import Reflux from 'reflux';
import {Button} from 'antd';
import {hashHistory, withRouter} from 'react-router';
import {DmsTab, TableView, AdvanceFormNew} from '../../components';
import {formatMoney, openNotice} from '../../utils/index.js';
import {getLowerList, fetchChannelList, idDelete, getOrderDetails, fetchGouHuo} from '../../service/order';
import moment from 'moment';
import {Store, Actions} from './store';
import {objectSerial, config} from 'Utils';

class LowerList extends Reflux.Component {
    constructor(props) {
        super(props);
        this.store = Reflux.initStore(Store); //创建一个Store实例
        this.channelName = this.props.location.query.channelName || '';
        this.customerManagementId = this.props.location.query.customerManagementId ? parseInt(this.props.location.query.customerManagementId, 10) : '';
        this.channelData = window.sessionStorage.getItem('cur_channel') || '{}';
        this.state = {
            opts: ['下浮设置'],
            userData: JSON.parse(window.localStorage.getItem('login_user_information') || '{}'),
            key: 0,
            rows: [],
            total: 1,
            searchObj: {
                cusName: '',
                detailName: '',
                removeFlag: '',
                s: 10,
                p: 1,
            },
            channel_type: [], /* 渠道类型 */
            regionOptions: [], /* 所属区域 */
            loading: true,
        };
        this.exportChange = this.exportChange.bind(this);
        this.pageChange = this.pageChange.bind(this);
        this.setFilterParam = this.setFilterParam.bind(this);
        this.advanceReset = this.advanceReset.bind(this);
        this.advanceSubmit = this.advanceSubmit.bind(this);
        this.routeLeaveHook = this.routeLeaveHook.bind(this);
        this.exportChange = this.exportChange.bind(this);
    }

    goView(url) {
        hashHistory.push(url);
    }

    /*导出*/
    exportChange() {
        let _searchObj = {...this.state.searchObj};
        delete _searchObj.s;
        delete _searchObj.p;
        let url = `${config.server}/api/v1/dms/tgOrder/exportTgOrder?${objectSerial(_searchObj)}`;
        window.open(url);
    };

    /*列表操作*/

    /*审核*/
    auditRecord(index) {
        console.log('audit' + index);
    }

    /*确认收货*/
    confirmRecord(index) {
        console.log('confirm' + index);
    }

    /*评价*/
    evaluationRecord(record) {
        hashHistory.push('order/evaluate/' + record.orderId + '/' + record.id);
    }

    /*编辑*/
    editRecord(record, index, value) {
        // if (record.orderType == '1') {
        this.goView(`lower/lowerAdd/${record.id}`);
        // }
    }

    // /*删除*/
    // deleteRecord(index) {
    //     // console.log('delet' + index);
    //     idDelete(this.state.rows[index].id).then(result => {
    //       if (result.code == 200) {
    //         openNotice('success', '删除成功', '');
    //         this.initData();

    //       }

    //     })
    // }
    /*筛选重置*/
    advanceReset() {
        let self = this;
        this.setState({
            key: 0,
            searchObj: {
                ...this.state.searchObj,
                cusName: '',
                detailName: '',
                removeFlag: '',
            }
        }, function () {
            self.initData();
        });
    };

    /* 筛选确认 */
    advanceSubmit(form) {
        /* 筛选确认 */
        let self = this;
        this.setState({
            key: this.state.searchObj.orderStatus,
            searchObj: {
                ...this.state.searchObj,
                p: 1
            }
        }, function () {
            self.initData();
        });
    };

    /*筛选*/
    setFilterParam(name, value) {
        if (name === 'orderTime') {
            this.setState({
                searchObj: {
                    ...this.state.searchObj,
                    startCreatedDate: value.from,
                    endCreatedDate: value.end
                }
            })
        } else {
            this.setState({searchObj: {...this.state.searchObj, [name]: value}})
        }
    };

    /*翻页*/
    pageChange(page, s) {
        let self = this;
        this.setState({searchObj: {...this.state.searchObj, s, p: page}}, function () {
            self.initData();
        });
    }

    /*获取列表数据*/
    initData() {
        let self = this;
        let searchObj = this.state.searchObj;
        self.setState({
            loading: true
        })
        searchObj.orderStatus = searchObj.orderStatus == 0 ? '' : searchObj.orderStatus;
        getLowerList(searchObj).then(function (result) {
            if (result && result.code == 200) {
                self.setState({
                    'rows': result.data || [],
                    'total': result.total,
                    'loading': false
                });
            } else {
                openNotice('error', '数据获取失败', '');
            }
        });
    }

    //离开当前路由时，更新store
    routeLeaveHook(nextLocation) {
        let path = nextLocation.pathname.split('/');
        if (path[1] === 'order') { //当下一个路由是详情页时，将useStore的值设为true
            Actions.useStoreChange(true);
            Actions.paramChange(this.state.searchObj);
        } else {
            Actions.useStoreChange(false);
            Actions.paramChange({});
        }
    }

    componentWillMount() {
        const data = this.store.state;
        if (data.useStore) { //根据useStore的值判断是否使用store中的数据
            this.setState({
                ...this.state,
                searchObj: {
                    ...this.state.searchObj,
                    ...data.params
                },
                key: data.params.orderStatus
            });
        }
    }

    componentDidMount() {
        let self = this;
        this.initData();
        /*渠道类型*/
        fetchChannelList().then(res => { //渠道
            if (res.status) {
                // let arr = [
                //     {
                //         text: '全部',
                //         value: ''
                //     }
                // ];
                let arr = [];
                res.data.forEach(x => {
                    arr.push({
                        text: x.name,
                        value: x.code
                    })
                });
                self.setState({channel_type: arr},
                )
            }
        });
        fetchGouHuo().then(res => { //渠道
            if (res.status) {
                let arr = [
                    {
                        text: '全部',
                        value: ''
                    }
                ];
                res.data.forEach(x => {
                    arr.push({
                        text: x.name,
                        value: x.id
                    })
                });
                self.setState({channel_GouHuo: arr},
                )
            }
        });
        //设置离开当前路由时的钩子函数
        this.props.router.setRouteLeaveHook(this.props.route, this.routeLeaveHook);
    }

    /*返回*/
    backTo() {
        window.history.go(-1);
    }

    /*导出*/
    exportChange() {
        let _searchObj = {...this.state.searchObj};
        delete _searchObj.s;
        delete _searchObj.p;
        let url = `${config.server}/api/v1/dms/trans/rate/exportLower?${objectSerial(_searchObj)}`;
        window.open(url);
    };

    render() {
        const {opts, key, rows, total, searchObj, channel_type, loading, channel_GouHuo} = this.state;
        const advanceProps = {
            fileds: [
                {
                    name: 'cusName',
                    label: '客户名称',
                    text: '输入客户名称',
                    type: 'default',
                    defaultValue: searchObj.cusName
                },
                {
                    name: 'detailName',
                    label: '明细类',
                    text: '输入明细类',
                    type: 'default',
                    defaultValue: searchObj.detailName
                },
                {
                    name: 'removeFlag',
                    label: '是否生效',
                    text: '选择是否生效',
                    options: [
                        {value: '', text: '全部'},
                        {value: '0', text: '是'},
                        {value: '1', text: '否'},
                    ],
                    multiple: false,//支持多选
                    type: 'select',
                    defaultValue: searchObj.orderStatus || ''
                },

            ],
            handle: this.advanceSubmit,
            reset: this.advanceReset,
            fieldHandle: this.setFilterParam
        };
        const tableViewProps = {
            loading: loading,//更新表格数据中
            rowKey: 'id',
            pageParam: {
                total,
                current: searchObj.p,//当前页码
                pageSize: searchObj.s,//当前分页数
                onChange: this.pageChange
            },
            columns: [
                {
                    title: '客户简称',
                    dataIndex: 'cusShortName'
                },
                {
                    title: '客户名称',
                    dataIndex: 'cusName'
                },
                {
                    title: '明细类',
                    dataIndex: 'categoryType',
                },
                // {
                //   title: '下浮类别',
                //   dataIndex: 'categoryType',
                // },

                {
                    title: '客户等级',
                    dataIndex: 'level'
                },
                {
                    title: '下浮率%',
                    dataIndex: 'priceRate'
                },
                {
                    title: '是否生效',
                    dataIndex: 'removeFlag',
                    render: (text) => text == 0 ? <span>{'是'}</span> : <span>{'否'}</span>
                },
                {
                    title: '最后更新日期',
                    dataIndex: 'lastUpdatedDate',
                    render: (text) => text ? new Date(text).format('yyyy-MM-dd') : ''
                },
                {
                    title: '操作',
                    dataIndex: 'done',
                    render: (text, record, index) => {
                        // if (record.orderStatus == 1 || record.orderStatus == 2 || record.orderStatus == 4)
                        return (<div>
                            <Button size={'small'} style={{float: 'left'}}
                                    onClick={this.editRecord.bind(this, record, index)}>编辑</Button>
                        </div>)
                    }
                },
            ],
            rows
        };
        let self = this;
        let backHide = (customerManagementId) => {
            if (customerManagementId) {
                return <Button onClick={self.backTo.bind(self)}>返回</Button>
            } else {
                return '';
            }
        }
        return <div>
            <DmsTab options={opts} defaultKey={0}>
                {backHide(this.customerManagementId)}
            </DmsTab>
            <div className="advanceForm-box">
                <div className="advanceForm-content">
                    <AdvanceFormNew {...advanceProps}/>
                </div>
            </div>
            <div className="dms-table-box">

                <div className="dms-table-head" style={{padding: '8px 8px 8px 0'}}>
                    <Button style={{position: 'absolute', bottom: 8, left: 2}}
                            onClick={this.goView.bind(this, '/lower/lowerAdd/0')}>新增</Button>

                    <Button icon="export" style={{position: 'absolute', bottom: 8, right: 2}}
                            onClick={this.exportChange}>导出</Button>
                    {/*<span>{total}个订单</span>
              <Button  style={{position:'absolute', bottom:8, right:394}} icon="export" onClick={this.exportChange}>导出</Button>
              
              <Button style={{position:'absolute', bottom:8, right:150}} onClick={this.goView.bind(this, '/shoppingCar/add/2')}>新增项目订单</Button>
              <Button style={{position:'absolute', bottom:8, right:0}}  onClick={this.goView.bind(this, '/shoppingCar/add/3')}>新增合作伙伴订单</Button>*/}
                </div>
                <TableView {...tableViewProps}/>
            </div>
        </div>
    }
}

//使用高阶组件withRouter来封装OrderList。目的是将router对象暴露出来
export default withRouter(LowerList);


// WEBPACK FOOTER //
// ./src/routes/lower/list.js